import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "./main/footer";
import api from "../services/httpService";
import "./contact.css";

const ContactPage = () => {
  const [contactInfo, setContactInfo] = useState(null);
  const [services, setServices] = useState([]);
  const [form, setForm] = useState({
    fullName: "",
    email: "",
    phone: "",
    message: "",
    service: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [submitMsg, setSubmitMsg] = useState("");

  useEffect(() => {
    fetchContactInfo();
    fetchThemeColors();
    fetchServices(); 
  }, []);

  const fetchContactInfo = async () => {
    try {
      const res = await api.get("/sentinix/contactforms");
      if (res.data.success && res.data.data) {
        const allData = Array.isArray(res.data.data) ? res.data.data : [res.data.data];
        const info = allData.find(item => item.title && item.title.trim() !== "");
        setContactInfo(info || null);
      }
    } catch (err) {
      console.error("Error fetching contact info:", err);
    }
  };

  const fetchThemeColors = async () => {
    try {
      const res = await api.get("/sentinix/dashboardsettings");
      if (res.data.success && res.data.data) {
        const allData = Array.isArray(res.data.data) ? res.data.data : [res.data.data];
        const latest = allData.sort((a, b) => b.id - a.id)[0];
        if (latest?.color1 && latest?.color2) {
          document.documentElement.style.setProperty("--theme-color1", latest.color1);
          document.documentElement.style.setProperty("--theme-color2", latest.color2);
        }
      }
    } catch (err) {
      console.error("Error fetching theme colors:", err);
    }
  };

  const fetchServices = async () => {
    try {
      const res = await api.get("/sentinix/services");
      if (res.data.success && res.data.data) {
        const serviceOnly = res.data.data.filter(
          (item) => item.type === "service" && !item.isDeleted
        );
        setServices(serviceOnly);
      }
    } catch (err) {
      console.error("Error fetching services:", err);
    }
  };

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setSubmitMsg("");
    try {
      const res = await api.post("/sentinix/contactsubmission", {
        name:    form.fullName,
        Email:   form.email,
        Phone:   form.phone,
        Message: form.message,
        service: form.service,
      });
      if (res.data.success) {
        setSubmitMsg("success");
        setForm({ fullName: "", email: "", phone: "", message: "", service: "" });
      } else {
        setSubmitMsg("error");
      }
    } catch (err) {
      console.error("Submit error:", err);
      setSubmitMsg("error");
    } finally {
      setSubmitting(false);
      setTimeout(() => setSubmitMsg(""), 5000);
    }
  };

  return (
    <>
      <Navbar />

      {/* ═══════════════ HERO ═══════════════ */}
      <section className="svc-hero">
        {contactInfo?.Imagekey && (
          <img className="svc-hero-img" src={contactInfo.Imagekey} alt="Contact" />
        )}
        {/* <div className="contact-hero__overlay">
          <h1 className="contact-hero__title">{contactInfo?.title || "Contact Us"}</h1>
          <p className="contact-hero__sub">{contactInfo?.description || ""}</p>
          <span className="contact-hero__scroll-arrow">↓</span>
        </div> */}
      </section>

      {/* ═══════════ INFO CARDS ═══════════ */}
      <section className="contact-cards">
        <div className="contact-card">
          <div className="contact-card__icon-wrap">
            <span className="contact-card__icon">📍</span>
          </div>
          <h3 className="contact-form__label">Address</h3>
          <p className="contact-card__body">{contactInfo?.Address || "-"}</p>
        </div>

        <div className="contact-card">
          <div className="contact-card__icon-wrap">
            <span className="contact-card__icon">✉️</span>
          </div>
          <h3 className="contact-form__label">Email</h3>
          <p className="contact-card__body">
            {contactInfo?.Email
              ? <a href={`mailto:${contactInfo.Email}`} className="contact-link">{contactInfo.Email}</a>
              : "-"}
          </p>
        </div>

        <div className="contact-card">
          <div className="contact-card__icon-wrap">
            <span className="contact-card__icon">📞</span>
          </div>
          <h3 className="contact-form__label">Phone</h3>
          <p className="contact-card__body">
            {contactInfo?.Phone
              ? <a href={`tel:+91${contactInfo.Phone}`} className="contact-link">+91 {contactInfo.Phone}</a>
              : "-"}
          </p>
          <div className="contact-card__socials">
            {contactInfo?.WhatsappNumber && (
              <a href={`https://wa.me/91${contactInfo.WhatsappNumber}`} target="_blank" rel="noreferrer" className="contact-card__social-btn" title="WhatsApp">
                <i className="fab fa-whatsapp"></i>
              </a>
            )}
            {contactInfo?.Instagram && (
              <a href={contactInfo.Instagram} target="_blank" rel="noreferrer" className="contact-card__social-btn" title="Instagram">
                <i className="fab fa-instagram"></i>
              </a>
            )}
            {contactInfo?.Linkedin && (
              <a href={contactInfo.Linkedin} target="_blank" rel="noreferrer" className="contact-card__social-btn" title="LinkedIn">
                <i className="fab fa-linkedin-in"></i>
              </a>
            )}
            {contactInfo?.GitHub && (
              <a href={contactInfo.GitHub} target="_blank" rel="noreferrer" className="contact-card__social-btn" title="GitHub">
                <i className="fab fa-github"></i>
              </a>
            )}
            {contactInfo?.Facebook && (
              <a href={contactInfo.Facebook} target="_blank" rel="noreferrer" className="contact-card__social-btn" title="Facebook">
                <i className="fab fa-facebook-f"></i>
              </a>
            )}
            {contactInfo?.Twitter && (
              <a href={contactInfo.Twitter} target="_blank" rel="noreferrer" className="contact-card__social-btn" title="Twitter">
                <i className="fab fa-twitter"></i>
              </a>
            )}
          </div>
        </div>
      </section>

      {/* ═══════════ MAP ═══════════ */}
      {contactInfo?.MapEmbedLink && (
        <section className="contact-map">
          <div className="contact-map__wrapper"
            dangerouslySetInnerHTML={{ __html: contactInfo.MapEmbedLink }} />
        </section>
      )}

      {/* ═══════════ CONTACT FORM ═══════════ */}
      <section className="contact-form-section">
        <h2 className="contact-form-section__title">Get In Touch</h2>
        <p className="contact-form-section__subtitle">
          We would love to hear from you. Fill in the form and we will get back to you shortly.
        </p>

        {submitMsg === "success" && (
          <div className="contact-toast contact-toast--success">
            ✅ Message sent successfully! We'll get back to you soon.
          </div>
        )}
        {submitMsg === "error" && (
          <div className="contact-toast contact-toast--error">
            ❌ Something went wrong. Please try again.
          </div>
        )}

        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="contact-form__grid">

            <div className="contact-form__field">
              <label className="contact-form__label">Full Name <span>*</span></label>
              <input className="contact-form__input"
                name="fullName" value={form.fullName}
                onChange={handleChange} required
                placeholder="Enter your full name" />
            </div>

            <div className="contact-form__field">
              <label className="contact-form__label">Email <span>*</span></label>
              <input className="contact-form__input"
                type="email" name="email" value={form.email}
                onChange={handleChange} required
                placeholder="Enter your email" />
            </div>

            <div className="contact-form__field full">
              <label className="contact-form__label">Select Service <span>*</span></label>
              <select
                className="contact-form__input"
                name="service"
                value={form.service}
                onChange={handleChange}
                required
              >
                <option value="">-- Select Service --</option>
                {services.map((service) => (
                  <option key={service.id} value={service.name}>
                    {service.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="contact-form__field full">
              <label className="contact-form__label">Phone <span>*</span></label>
              <input className="contact-form__input"
                name="phone" value={form.phone}
                onChange={handleChange} required
                placeholder="Enter your phone number" maxLength={10} />
            </div>

            <div className="contact-form__field full">
              <label className="contact-form__label">Message <span>*</span></label>
              <textarea className="contact-form__textarea"
                name="message" value={form.message}
                onChange={handleChange} rows={5} required
                placeholder="Write your message here" />
            </div>

          </div>
          <div className="contact-form__footer">
            <button type="submit" className="contact-form__submit" disabled={submitting}>
              {submitting ? "Sending..." : "Send Message"}
            </button>
          </div>
        </form>
      </section>

      {/* ═══════════ WHATSAPP FAB ═══════════ */}
      {contactInfo?.WhatsappNumber && (
        <a
          href={`https://wa.me/91${contactInfo.WhatsappNumber}`}
          target="_blank"
          rel="noreferrer"
          className="whatsapp-fab"
          title="WhatsApp"
        >
          <i className="fab fa-whatsapp"></i>
        </a>
      )}

      <Footer />
    </>
  );
};

export default ContactPage;